import script from "./AppSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./AppSidebar.vue?vue&type=style&index=0&id=88bcc9d0&scoped=true&lang=scss"
import "./AppSidebar.vue?vue&type=style&index=1&id=88bcc9d0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88bcc9d0"]])

export default __exports__